export const PLACE_OPTIONS = {
  '01': 'pharmacie',
  '02': "hôpital (établissement public de santé)",
  '03': 'clinique privée',
  '04': "laboratoire d'analyses médicales",
  '05': "autre établissement de soins",
  '06': 'organisme AMO (Caisse, Mutuelle, ...)',
  '07': 'organisme AMC',
  '08': 'mairie',
  '09': 'bureau de poste',
  '10': 'centre de santé',
  '11': 'médecin',
  '12': 'dentiste',
  '13': 'auxiliaire médical(e)',
  '14': 'professionnel de la LPP (fournisseur, prestataires de santé)',
  '15': 'transporteur (Transporteur sanitaire et/ou taxi conventionné)',
  '99': "autres lieux d'installation (prison, banque, …)",
} as const

export type PlaceCode = keyof typeof PLACE_OPTIONS

export const getPlaceLabel = (code: string): string => {
  return PLACE_OPTIONS[code as PlaceCode] || code
}

export const PLACE_OPTIONS_ARRAY = Object.entries(PLACE_OPTIONS).map(([value, label]) => ({
  value,
  label,
}))

